<template>
  <transition name="loader">
    <div
      v-show="loading"
      class="loader"
      :class="{
        'low-z-index': lowZIndex,
        'high-z-index': highZIndex,
        'to-bottom': position === 'bottom',
        'to-top': position === 'top',
        'center-fixed': position === 'center-fixed',
        'whole-page': position === 'whole-page',
      }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="32"
        height="32"
      >
        <path
          class="full-circle"
          d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        />
        <path
          class="partial-circle"
          d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"
        />
      </svg>
    </div>
  </transition>
</template>

<script>
import Loader from 'Components/loader/Loader.vue';

export default {
  name: 'Loader',
  extends: Loader,
};
</script>
